import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

const LoginLoading = () => {
  const { token } = useParams();
  const { loginWithToken } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState('Validando token...');

  useEffect(() => {
    const authenticate = async () => {
      try {
        setStatus('Autenticando...');
        await loginWithToken(token);
        setStatus('¡Acceso concedido!');
        toast.success('¡Bienvenido!');
        setTimeout(() => {
          navigate('/dashboard/billing');
        }, 500);
      } catch (error) {
        setStatus('Error de autenticación');
        toast.error('Token inválido o expirado');
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      }
    };

    if (token) {
      authenticate();
    } else {
      navigate('/login');
    }
  }, [token, loginWithToken, navigate]);

  return (
    <div 
      className="min-h-screen flex flex-col items-center justify-center p-4"
      style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)'
      }}
      data-testid="login-loading-screen"
    >
      <div className="text-center">
        <Loader2 className="h-16 w-16 text-white animate-spin mx-auto mb-6" data-testid="loading-spinner" />
        <h2 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          {status}
        </h2>
        <p className="text-white/80" data-testid="loading-status">
          Por favor espera mientras procesamos tu acceso...
        </p>
      </div>
    </div>
  );
};

export default LoginLoading;